import cdnApi from './cdn';
// import cmsApi from './cms';
import countryApi from './country';
import cdnNexonstaticApi from './cdn-nexonstatic';

const pluginAPI = {
	install(Vue) {
		Vue.prototype.$cdnAPI = cdnApi;
		Vue.prototype.$countryAPI = countryApi;
		Vue.prototype.$cdnNexonstaticApi = cdnNexonstaticApi;
	},
};

export default pluginAPI;
